/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Payment account creation status
 */
export enum CreationStatus {
  PENDING = 'PENDING',
  CREATED = 'CREATED',
  ACTIVATED = 'ACTIVATED',
}
